import LocalStorage from '../data/local-storage';
import CONFIG from '../config/app-config';

class AuthService {
  constructor() {
    this.isAuthenticated = false;
    this.user = {};
    this.token = null;
  }

  load() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    if (token && userData) {
      this.isAuthenticated = true;
      this.user = JSON.parse(userData);
      this.token = token;
    } else {
      this.isAuthenticated = false;
      this.user = {};
      this.token = null;
    }
  }

  setAuthState(isAuth, user = {}, token = null) {
    this.isAuthenticated = isAuth;
    this.user = user;
    this.token = token;
    if (isAuth) {
      LocalStorage.setItem('heliaedu_token', token);
      LocalStorage.setObject('heliaedu_user', user);
    } else {
      LocalStorage.removeItem('heliaedu_token');
      LocalStorage.removeItem('heliaedu_user');
    }
    this.updateAuthUI();
  }

  updateAuthUI() {
    const isAuthenticated = this.isAuthenticated;
    const user = this.user;
    document.body.classList.toggle('guest-mode', !isAuthenticated);
    document.querySelectorAll('.guest-element').forEach(el => el.style.display = !isAuthenticated ? '' : 'none');
    document.querySelectorAll('.user-element').forEach(el => el.style.display = isAuthenticated ? '' : 'none');
    const userPhoto = document.querySelector('.user-photo');
    if (!userPhoto) return;
    const newUserPhoto = userPhoto.cloneNode(true);
    userPhoto.parentNode.replaceChild(newUserPhoto, userPhoto);
    if (!isAuthenticated) {
      newUserPhoto.setAttribute('href', '#/auth');
      newUserPhoto.setAttribute('data-text_tip', 'Masuk');
      newUserPhoto.classList.add('ubah-bentuk');
      newUserPhoto.innerHTML = `
        <span class="material-symbols-rounded">login</span>
        <span class="sr-only">Masuk</span>
      `;
    } else {
      const base = CONFIG.AVATAR_BASE_URL || 'https://api.dicebear.com/7.x/initials/svg';
      newUserPhoto.setAttribute('href', '#/profile');
      newUserPhoto.setAttribute('data-text_tip', 'Profil');
      newUserPhoto.classList.remove('ubah-bentuk');
      newUserPhoto.innerHTML = `
        <img src="${base}?seed=${encodeURIComponent(user.name || 'User')}" alt="Foto profil ${user.name}" width="32" height="32" loading="lazy">
        <span class="sr-only">Profil ${user.name}</span>
      `;
    }
  }
}

export default new AuthService();
